module.exports = __webpack_public_path__ + "img/footer-text_900.907d0b76.png";